import classNames from "classnames";
import React from "react";
import styles from "./pill.module.scss";

const Pill = ({
  children,
  grass,
  cheddar,
  sky,
  deepRed,
  cement,
  desertstorm,
  className,
  cyan,
  xsmall,
  style,
}) => {
  return (
    <div style={style}>
      <span
        className={classNames(styles.pill, className, {
          [`${styles.grass}`]: grass,
          [`${styles.cheddar}`]: cheddar,
          [`${styles.deepRed}`]: deepRed,
          [`${styles.sky}`]: sky,
          [`${styles.cement}`]: cement,
          [`${styles.desertstorm}`]: desertstorm,
          [`${styles.cyan}`]: cyan,
          [`${styles.xsmall}`]: xsmall,
        })}
      >
        {children}
      </span>
    </div>
  );
};

export default Pill;
